var _defs, _rect, _rect2, _rect3, _rect4, _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCreateExperimentCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    zoomAndPan: "magnify",
    viewBox: "0 0 375 374.999991",
    height: 500,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "id1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 91.667969 91.667969 L 283.667969 91.667969 L 283.667969 283.667969 L 91.667969 283.667969 Z M 91.667969 91.667969 ",
    clipRule: "nonzero"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -37.5,
    width: 450,
    fill: "#ffffff",
    y: -37.499999,
    height: 449.999989,
    fillOpacity: 1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -37.5,
    width: 450,
    fill: "#ffffff",
    y: -37.499999,
    height: 449.999989,
    fillOpacity: 1
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: -37.5,
    width: 450,
    fill: "#ffffff",
    y: -37.499999,
    height: 449.999989,
    fillOpacity: 1
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: -37.5,
    width: 450,
    fill: "#ffffff",
    y: -37.499999,
    height: 449.999989,
    fillOpacity: 1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#f7f9ff",
    d: "M 350.613281 375 L 24.386719 375 C 10.949219 375 0 364.050781 0 350.613281 L 0 24.386719 C 0 10.949219 10.949219 0 24.386719 0 L 350.613281 0 C 364.050781 0 375 10.949219 375 24.386719 L 375 350.613281 C 375 364.050781 364.050781 375 350.613281 375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#id1)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#292f33",
    d: "M 265.667969 169.667969 L 205.667969 169.667969 L 205.667969 109.667969 C 205.667969 99.726562 197.609375 91.667969 187.667969 91.667969 C 177.726562 91.667969 169.667969 99.726562 169.667969 109.667969 L 169.667969 169.667969 L 109.667969 169.667969 C 99.726562 169.667969 91.667969 177.726562 91.667969 187.667969 C 91.667969 197.609375 99.726562 205.667969 109.667969 205.667969 L 169.667969 205.667969 L 169.667969 265.667969 C 169.667969 275.609375 177.726562 283.667969 187.667969 283.667969 C 197.609375 283.667969 205.667969 275.609375 205.667969 265.667969 L 205.667969 205.667969 L 265.667969 205.667969 C 275.609375 205.667969 283.667969 197.609375 283.667969 187.667969 C 283.667969 177.726562 275.609375 169.667969 265.667969 169.667969 Z M 265.667969 169.667969 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateExperimentCard);
export default __webpack_public_path__ + "static/media/create-experiment-card.07dd425b5060434c04a233ce5775e944.svg";
export { ForwardRef as ReactComponent };